module.exports = __webpack_public_path__ + "static/media/BurbankBigRegular-Bold.d6ff076a.woff2";